import styled from 'styled-components';

import theme from '@theme';

export const Wrapper = styled.div<{
  isOneWay?: boolean;
  rightBorder?: boolean;
}>`
  height: 80px;
  width: ${(props) => (props.isOneWay ? '150px' : '75px')};
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: #000;
  border-right: ${(props) =>
    props.isOneWay
      ? '0px solid #000'
      : props.rightBorder
      ? '0px solid #000'
      : '1px solid #000'};

  ${theme.mediaQueries.PHONE} {
    width: 100%;
    border-color: #ebebeb;
  }
`;
export const MainLabel = styled.label`
  font-size: 11px;
  font-weight: 400;
  margin-bottom: 5px;
  cursor: pointer;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
`;

export const Styledlabel = styled.label`
  font-weight: bold;
  cursor: pointer;
`;

export const SubLabel = styled.div`
  font-size: 13px;
  cursor: pointer;
`;
